import { createSlice } from '@reduxjs/toolkit';
import UserService from '../../utils/UserService';

const initialState = {
  userInfo: UserService.getUserInfo(),
  userSubscriptionInfo: UserService.getUserSubscriptionInfo(),
  unreads: null,
  totalNotificationCount: UserService.getNotificationCurrentCount(),
  subscriptionPlans: null,
  investorId: UserService.getInvestorId(),
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserInfo(state, action) {
      state.userInfo = action.payload;
    },
    setUserSubscriptionInfo(state, action) {
      state.userSubscriptionInfo = action.payload;
    },
    setUnreads(state, action) {
      state.unreads = action.payload
    },
    setTotalNotificationCount(state, action) {
      state.totalNotificationCount = action.payload
    },
    setSubscriptionPlans(state, action) {
      state.subscriptionPlans = action.payload
    },
    setInvestorId(state, action) {
      state.investorId = action.payload;
    },
  },
});


export const { setUserInfo, setUserSubscriptionInfo, setTotalNotificationCount, setUnreads, setSubscriptionPlans, setInvestorId } = userSlice.actions;
export default userSlice.reducer;
